import { render, staticRenderFns } from "./HoroscopeBookDialog.vue?vue&type=template&id=dba65e6a&scoped=true&"
import script from "./HoroscopeBookDialog.vue?vue&type=script&lang=js&"
export * from "./HoroscopeBookDialog.vue?vue&type=script&lang=js&"
import style0 from "./HoroscopeBookDialog.vue?vue&type=style&index=0&id=dba65e6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba65e6a",
  null
  
)

export default component.exports